function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import MultiSwitch from 'react-multi-switch-toggle';
import './AwardSelector.css';

var AwardSelector = /*#__PURE__*/function (_React$Component) {
  _inherits(AwardSelector, _React$Component);

  function AwardSelector(props) {
    var _this;

    _classCallCheck(this, AwardSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AwardSelector).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onToggle", function (award) {
      var options = _this.state.options;
      var _this$props = _this.props,
          updateLogBookEntry = _this$props.updateLogBookEntry,
          entry = _this$props.entry;
      entry.award = options[award];
      updateLogBookEntry();
    });

    _this.state = {
      options: ['Certificate', 'Ribbon', 'Trophy', 'Stamps']
    };
    return _this;
  }

  _createClass(AwardSelector, [{
    key: "render",
    value: function render() {
      var changeMotoNumber = this.changeMotoNumber,
          changeMotoFinish = this.changeMotoFinish,
          handleKeyPress = this.handleKeyPress;
      var _this$props2 = this.props,
          logBookEntry = _this$props2.logBookEntry,
          entry = _this$props2.entry,
          width = _this$props2.width;
      var options = this.state.options;
      var main = entry.motos.find(function (moto) {
        return moto.name === 'main';
      });
      return React.createElement("div", {
        className: "award-selector ".concat(main && main.finish !== '' ? 'show' : 'hide')
      }, React.createElement(MultiSwitch, {
        texts: options,
        eachSwitchWidth: width / 4 - 4,
        selectedSwitch: main && options.indexOf(main.award),
        bgColor: 'rgba(var(--background-color), 1)',
        onToggleCallback: this.onToggle,
        fontColor: 'rgba(var(--foreground-color), .5)',
        selectedFontColor: 'rgba(var(--active-color), 1)',
        selectedSwitchColor: 'rgba(var(--background-color), 1)',
        borderColor: 'rgba(var(--background-color), 1)',
        borderWidth: '1px',
        height: '35px',
        fontSize: '14px',
        fontWeight: '100'
      }));
    }
  }]);

  return AwardSelector;
}(React.Component);

export default AwardSelector;